import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FileUpload } from '.';
import { useFileUpload } from '../hooks';
import { stopEvent } from './domUtils';
export default function FileUploadModalBody(_ref) {
  let {
    upload,
    uploadAllowed,
    setFileNotSelected,
    customFormName = 'file',
    setLocalFile
  } = _ref;
  const {
    t
  } = useTranslation();
  const [file, isFileUploadLoading, setFile] = useFileUpload(upload, customFormName, uploadAllowed);
  const selectFirstFile = files => {
    const file = files[0];
    setFile(file);
    if (setLocalFile) {
      setLocalFile(file);
    }
  };
  const onDropSelectFirstFile = e => {
    stopEvent(e, false);
    const fileList = Array.from(e.dataTransfer.files);
    if (fileList.length === 1) {
      selectFirstFile(fileList);
    } else {
      alert('Please drop only one file.');
    }
  };
  useEffect(() => {
    file !== null && file !== void 0 && file.name ? setFileNotSelected(false) : setFileNotSelected(true);
  }, [file, setFileNotSelected]);
  return /*#__PURE__*/React.createElement("div", {
    onDragEnter: e => stopEvent(e, false),
    onDragOver: e => stopEvent(e, false),
    onDragLeave: e => stopEvent(e, false),
    onDrop: onDropSelectFirstFile,
    "data-testid": "fileModal"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(FileUpload, {
    loading: isFileUploadLoading,
    title: t('select_file'),
    file: file,
    onSelectFile: setFile,
    setLocalFile: setLocalFile,
    fileDepositDesign: true
  }))));
}